import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-container" }
const _hoisted_2 = { class: "settings-header" }
const _hoisted_3 = { class: "settings-content" }
const _hoisted_4 = { class: "settings-sidebar" }
const _hoisted_5 = { class: "settings-main" }
const _hoisted_6 = { class: "setting-row" }
const _hoisted_7 = { class: "setting-control" }
const _hoisted_8 = { class: "setting-row" }
const _hoisted_9 = { class: "setting-control" }
const _hoisted_10 = { class: "setting-row" }
const _hoisted_11 = { class: "setting-control" }
const _hoisted_12 = { class: "setting-row" }
const _hoisted_13 = { class: "setting-control" }
const _hoisted_14 = { class: "setting-row" }
const _hoisted_15 = { class: "setting-control" }
const _hoisted_16 = { class: "setting-row" }
const _hoisted_17 = { class: "setting-control" }
const _hoisted_18 = { class: "setting-row" }
const _hoisted_19 = { class: "setting-control" }
const _hoisted_20 = { class: "setting-row" }
const _hoisted_21 = { class: "setting-control" }

import { ref } from 'vue'

// Estado para los toggles y selecciones

export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const showCode = ref(false)
const showSuggestions = ref(true)
const theme = ref('System')
const language = ref('Auto-detect')

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-h4 font-weight-medium" }, "Settings", -1)),
      _createVNode(_component_v_btn, {
        icon: "",
        class: "close-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "30" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("mdi-close")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_list, {
          nav: "",
          class: "settings-list"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-cog",
              title: "General",
              class: "settings-list-item active"
            }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-bell-outline",
              title: "Notificaciones",
              class: "settings-list-item"
            }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-account-cog-outline",
              title: "Personalizacion",
              class: "settings-list-item"
            }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-database-cog-outline",
              title: "Control datos",
              class: "settings-list-item"
            }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-file-document-outline",
              title: "Data",
              class: "settings-list-item"
            }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-apps",
              title: "Servidor",
              class: "settings-list-item"
            }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-shield-outline",
              title: "Contraseña",
              class: "settings-list-item"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "setting-label" }, "Theme", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_select, {
              modelValue: theme.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((theme).value = $event)),
              items: ['Light', 'Dark', 'System'],
              variant: "plain",
              "hide-details": "",
              class: "dropdown-select",
              density: "comfortable"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-chevron-down")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "setting-label" }, "Always show code when using data analyst", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_switch, {
              modelValue: showCode.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showCode).value = $event)),
              color: "success",
              "hide-details": "",
              inset: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "setting-label" }, "Show follow up suggestions in chats", -1)),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_switch, {
              modelValue: showSuggestions.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showSuggestions).value = $event)),
              color: "success",
              "hide-details": "",
              inset: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "setting-label" }, "Language", -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_select, {
              modelValue: language.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((language).value = $event)),
              items: ['English', 'Spanish', 'French', 'Auto-detect'],
              variant: "plain",
              "hide-details": "",
              class: "dropdown-select",
              density: "comfortable"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-chevron-down")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "setting-label" }, "Archived chats", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_v_btn, {
              class: "action-button",
              variant: "outlined",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode(" Manage ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "setting-label" }, "Borar todos los ajustes", -1)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_btn, {
              class: "action-button",
              variant: "outlined",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode(" Archive all ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "setting-label" }, "Reiniciar ajusets", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_btn, {
              color: "error",
              class: "action-button",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createTextVNode(" Reinciar ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "setting-label" }, "Log out on this device", -1)),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_v_btn, {
              class: "action-button",
              variant: "outlined",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode(" Log out ")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})